import React from 'react'
import UserLayout from '../layouts/UserLayout'
import { Box } from '@mui/material'
import { useLocation } from 'react-router-dom'
import GuestOrderItem from './storeManager/GuestOrderItem'

export default function SearchGuestDetail() {
	const { state } = useLocation()

	return (
		<UserLayout>
			<Box sx={{ padding: '20px' }}>
				<GuestOrderItem
					item={state?.result}
					handleSubmit={() => {}}
					setOrderEditing={() => {}}
					deleteGuestOrder={() => {}}
					index={-1}
				/>
			</Box>
		</UserLayout>
	)
}

